

exports.__esModule = true;

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

exports['default'] = _squid.$Component.extend('$xoApplyPPCDirective', {
    tag: 'apply-ppc',
    template: '<div></div>',

    props: {
        token: {
            type: 'var'
        },
        redirect: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var country = this.models.checkoutAppData.merchant.merchant_country;

            return (0, _squid.$pxp)('xo_hermes_cape_migration', {
                'ctx.COUNTRY': country
            }, 'xo_cape_migration_test').then(function (result) {
                if (result && result.treatment_name === 'xo_cape_migration_test') {
                    _this.goto('checkout.redirectToCape');
                } else {
                    var queryString = _squid.$util.queryStringSplice(_squid.$util.queryString(), {
                        'flow': '1-P',
                        'token': _this.token,
                        'applyCredit': '1'
                    }, ['cmd']);

                    throw new _squid.$FallbackError({
                        reason: 'bml_not_supported',
                        product: 'aries',
                        entryPoint: 'bml',
                        params: {
                            state: queryString
                        }
                    });
                }
            });
        }
    }
});


_squid.$Component;

_squid.$FallbackError;

_squid.$util;

_squid.$pxp;

_checkout.$CheckoutAppDataModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/apply-ppc/directive.js
// module id = ./components/xo-credit-components/src/apply-ppc/directive.js
// module chunks = 1